import { useLanguage } from '@/contexts/AppContext';

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const translations = {
  ko: {
    title: '로그아웃',
    message: '정말 로그아웃 하시겠습니까?',
    cancel: '취소',
    confirm: '로그아웃'
  },
  es: {
    title: 'Cerrar sesión',
    message: '¿Realmente quieres cerrar sesión?',
    cancel: 'Cancelar',
    confirm: 'Cerrar sesión'
  },
  en: {
    title: 'Log out',
    message: 'Do you really want to log out?',
    cancel: 'Cancel',
    confirm: 'Log out'
  }
};

export function LogoutConfirmModal({ isOpen, onClose, onConfirm }: LogoutConfirmModalProps) {
  const { language } = useLanguage();
  const t = translations[language];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-background rounded-[10px] shadow-2xl w-[90%] max-w-[340px] overflow-hidden animate-scaleIn">
        {/* Content */}
        <div className="p-6">


          {/* Title */}
          <h3 className="text-[18px] font-bold text-foreground text-center mb-2">
            {t.title}
          </h3>

          {/* Message */}
          <p className="text-[14px] text-muted-foreground text-center mb-6">
            {t.message}
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            {/* Cancel Button */}
            <button
              onClick={onClose}
              className="flex-1 bg-muted text-foreground rounded-[5px] py-3 text-[14px] font-bold hover:bg-border active:scale-95 transition-all duration-200 text-center"
            >
              {t.cancel}
            </button>

            {/* Confirm Button */}
            <button
              onClick={onConfirm}
              className="flex-1 bg-secondary text-white rounded-[5px] py-3 text-[14px] font-bold hover:bg-secondary/90 active:bg-secondary/80 active:scale-95 transition-all duration-200 text-center"
            >
              {t.confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
